import { ErrorTicket } from '@/components/ErrorTicket';

export const FatalErrorFallbackUI = () => {
  return <ErrorTicket />;
};
